var _g, _circle, _circle2, _circle3, _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFingerprintPulse({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 239,
    height: 239,
    viewBox: "0 0 239 239",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 119.5,
    cy: 119.5,
    r: 78.5,
    fill: "url(#paint0_linear)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 119.5,
    cy: 119.5,
    r: 66,
    stroke: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 119.5,
    cy: 119.5,
    r: 96,
    stroke: "url(#paint1_linear)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 119.5,
    cy: 119.5,
    r: 119,
    stroke: "url(#paint2_linear)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.768 116.336C92.4106 116.448 92.03 116.464 91.6646 116.382C91.2991 116.3 90.9618 116.123 90.6864 115.869C90.4111 115.615 90.2075 115.294 90.0963 114.936C89.985 114.578 89.9699 114.198 90.0525 113.832C91.2924 108.674 96.0071 96.0594 113.183 90.7536C120.623 88.4553 127.758 88.4161 134.381 90.6361C139.829 92.4549 143.446 95.3011 145.177 96.6767C145.616 97.0245 145.9 97.5327 145.965 98.0895C146.03 98.6462 145.871 99.206 145.523 99.6456C145.519 99.651 145.514 99.6565 145.51 99.6619C145.153 100.103 144.637 100.386 144.073 100.45C143.509 100.514 142.943 100.354 142.496 100.004C139.361 97.5341 129.848 90.0306 114.431 94.7932C99.3765 99.4436 95.2872 110.321 94.2265 114.772C94.146 115.139 93.9681 115.478 93.7115 115.754C93.4549 116.029 93.129 116.23 92.768 116.336L92.768 116.336Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M139.582 145.553C139.411 145.608 139.235 145.642 139.056 145.652C125.637 146.375 117.1 135.227 116.75 134.763L116.685 134.655C116.471 134.324 111.305 126.464 113.579 120.222C114.624 117.369 116.934 115.366 120.465 114.275C123.749 113.26 126.436 113.561 128.723 115.194C130.599 116.525 131.801 118.509 132.966 120.425C135.389 124.405 136.874 126.429 141.479 125.261C143.502 124.748 144.446 123.167 144.877 121.935C146.039 118.584 145.009 114.015 142.286 110.559C138.768 106.074 128.922 98.6259 116.774 102.378C111.586 103.981 107.341 107.139 104.498 111.487C102.142 115.096 100.773 119.578 100.743 123.758C100.696 131.54 107.074 141.779 107.135 141.871C107.281 142.106 107.381 142.368 107.426 142.641C107.472 142.914 107.464 143.194 107.401 143.464C107.339 143.734 107.224 143.989 107.064 144.214C106.903 144.44 106.699 144.632 106.464 144.778C106.458 144.783 106.451 144.787 106.445 144.791C105.963 145.091 105.383 145.19 104.83 145.066C104.276 144.942 103.794 144.605 103.486 144.129C103.198 143.66 96.3878 132.744 96.4427 123.749C96.5191 114 102.444 102.364 115.522 98.3243C121.567 96.4569 127.919 96.7708 133.897 99.2219C138.531 101.133 142.819 104.297 145.654 107.91C149.276 112.522 150.551 118.559 148.903 123.27C147.804 126.411 145.529 128.579 142.505 129.353C134.624 131.358 131.537 126.311 129.285 122.629C126.973 118.854 125.694 117.085 121.698 118.319C119.504 118.997 118.152 120.083 117.584 121.643C116.81 123.777 117.543 126.511 118.295 128.428C118.302 128.448 118.31 128.468 118.318 128.488C119.281 130.924 120.784 133.11 122.714 134.882C125.806 137.737 131.546 141.807 138.861 141.415C139.42 141.38 139.97 141.569 140.39 141.94C140.81 142.31 141.066 142.833 141.1 143.392C141.101 143.399 141.101 143.406 141.102 143.413C141.119 143.887 140.979 144.353 140.705 144.74C140.43 145.127 140.035 145.413 139.582 145.553L139.582 145.553Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.31 149.561C123.031 149.648 122.736 149.676 122.445 149.646C122.154 149.616 121.872 149.526 121.616 149.384C114.998 145.634 110.352 140.591 107.007 133.522L106.993 133.479C104.885 128.766 103.615 121.565 106.415 115.479C108.482 110.989 112.362 107.832 117.927 106.113C124.51 104.08 130.639 105.577 135.67 110.422C137.957 112.658 139.818 115.293 141.159 118.197C141.373 118.719 141.373 119.305 141.158 119.827C140.944 120.35 140.532 120.766 140.013 120.987C139.493 121.209 138.907 121.216 138.382 121.009C137.857 120.802 137.435 120.396 137.206 119.88C136.07 117.456 134.502 115.259 132.578 113.398C128.7 109.709 124.193 108.619 119.165 110.172C114.82 111.514 111.829 113.887 110.297 117.225C108.088 122.03 109.226 128.03 110.876 131.722C113.826 137.974 117.917 142.409 123.742 145.703C123.983 145.839 124.194 146.02 124.365 146.238C124.535 146.455 124.661 146.704 124.735 146.97C124.809 147.236 124.83 147.514 124.797 147.789C124.764 148.063 124.677 148.328 124.541 148.568C124.536 148.578 124.53 148.587 124.525 148.597C124.253 149.058 123.821 149.401 123.31 149.561Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 17,
    y: 33,
    width: 205,
    height: 205,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.27451 0 0 0 0 0.0627451 0 0 0 0 0.607843 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 198,
    y1: 41,
    x2: 13.7779,
    y2: 85.6275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B35C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#46109B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 216,
    y1: 23,
    x2: -10.4641,
    y2: 77.8606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B35C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#46109B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 239,
    y1: 0,
    x2: -41.44,
    y2: 67.9362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B35C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#46109B"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFingerprintPulse);
export default __webpack_public_path__ + "static/media/fingerprint-pulse.53a9d8b91fc1fc6610ffa5774b189a2a.svg";
export { ForwardRef as ReactComponent };